module.exports = __webpack_public_path__ + "img/icon_clip.fae31ac0.svg";